import React from 'react';
import { TableRow, TableCell, Tooltip, IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { TableRowActions, RevisionHistory } from '../../../../shared_elements';
import HistoryIcon from '@material-ui/icons/History';
import CashTxCRU from './CashTxCRU';
import NumericLabel from 'react-pretty-numbers';
import { getCurrencyFormat, checkPermission } from '../../../../utils_v2';
import moment from 'moment';
import { displayDateFormatShort } from '../../../../constants';
export default function CashTxList({item, previewDetail, getResponseBack, contractInfo,deleteCashAndNonCash, securityCurrency}){
  return(
    <TableRow hover tabIndex={-1}>
      <TableCell >{item.reference_number ? item.reference_number:'--'}</TableCell>
      <TableCell >{item.transaction_date ? moment(item.transaction_date).format(displayDateFormatShort):'--'}</TableCell>
      <TableCell >{item.retention_period_start_date ? moment(item.retention_period_start_date).format(displayDateFormatShort):'--'} - {item.retention_period_end_date ? moment(item.retention_period_end_date).format(displayDateFormatShort):'--'}</TableCell>
      <TableCell >{item.amount ? <NumericLabel params={getCurrencyFormat({currency: securityCurrency, shortFormat:false})}>{item.amount}</NumericLabel>:'--'}</TableCell>
      <TableCell>
        <CashTxCRU id={item.id} securityDepositId={item.security_deposit_id} m="V" getResponseBack={getResponseBack} contractInfo={contractInfo}/>
        {checkPermission('contracts','security_deposit', 'D') ? <DeleteIcon fontSize='small' color='secondary' style={{cursor:'pointer'}} onClick={()=>deleteCashAndNonCash(item.id)}/>: null}
      </TableCell>
    </TableRow>
  )
}
